import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Platform } from "react-native";
import { BreakpointIndexProvider } from "../css/breakpoints";
import { DripsyThemeContext } from "./context";
var useIsSSRReady = function(param) {
    var _param_ssr = param.ssr, ssr = _param_ssr === void 0 ? false : _param_ssr;
    var _useState = _sliced_to_array(useState(function() {
        if (Platform.OS !== "web") {
            return true;
        }
        if (ssr) {
            return false;
        }
        return true;
    }), 2), ready = _useState[0], setReady = _useState[1];
    var isSSR = useRef(ssr);
    useEffect(function() {
        if (isSSR.current) {
            setReady(true);
        }
    }, []);
    return {
        ready: ready
    };
};
export function DripsyProvider(p) {
    var _p_ssrPlaceholder = p.ssrPlaceholder, ssrPlaceholder = _p_ssrPlaceholder === void 0 ? null : _p_ssrPlaceholder, ssr = p.ssr, theme = p.theme, children = p.children;
    var ready = useIsSSRReady({
        ssr: ssr
    }).ready;
    var context = useMemo(function() {
        return {
            theme: theme
        };
    }, [
        theme
    ]);
    if (!ready) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: ssrPlaceholder
        });
    }
    return /*#__PURE__*/ _jsx(DripsyThemeContext.Provider, {
        value: context,
        children: /*#__PURE__*/ _jsx(BreakpointIndexProvider, {
            children: children
        })
    });
}
/**
 * @deprecated use DripsyProvider instead
 */ export function ThemeProvider() {
    throw new Error("\uD83C\uDF77 [Dripsy] ThemeProvider is deprecated, please use DripsyProvider instead.");
}
